import { render } from "./GtinManagementList.vue?vue&type=template&id=4a1e9e0a&scoped=true"
import script from "./GtinManagementList.vue?vue&type=script&lang=js"
export * from "./GtinManagementList.vue?vue&type=script&lang=js"

import "./GtinManagementList.vue?vue&type=style&index=0&id=4a1e9e0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1e9e0a"]])

export default __exports__